<template>
  <div class="usersGroup">
    <div class="search fixed_wrap">
      <div class="flex-center margin-bot">
        <dl class="flex-right-input" @click="showPicker = true">
          <input type="text" placeholder="请选择" readonly v-model="currentCityObj.name" />
          <van-icon name="arrow-down" />
        </dl>
        <van-search class="flex1" v-model="userName" placeholder="搜索客户名称" @clear="searchCustomer" />
        <span :span="4" class="search-text" @click="searchCustomer">搜索</span>
      </div>
    </div>
    <div class="user_wrap">
      <div class="header_checkbox">
        <h4>选择员工</h4>
        <div class="allCheckbox" v-show="showAllChecks">
          <span ref="allChecked">全选</span>
          <van-checkbox shape="square" v-model="checked" @click="allCheckbox" />
        </div>
      </div>
      <van-checkbox-group v-model="ruleForm.selectArr" ref="checkboxGroup">
        <van-cell-group>
          <van-cell v-for="(item, index) in userOption" :key="item.weUserId" clickable @click="toggle(index)">
            <template #title>
              <div class="flex-user">
                <van-image round :src="item.headImg" lazy-load />
                <span>{{ item.realname }}</span>
              </div>
            </template>
            <template #right-icon>
              <van-checkbox :name="JSON.stringify(item)" ref="checkboxes" shape="square" />
            </template>
          </van-cell>
          <!--          </lazy-component>-->
        </van-cell-group>
      </van-checkbox-group>
    </div>
    <div class="fixed_bottom fixed_horizo_center">
      <div class="button_bottom">
        <dl @click="resetUser">取消</dl>
        <dl @click="ensureComfirm" ref="ensureConfirm">确认</dl>
      </div>
    </div>

    <!--校区列表-->
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar :columns="allCityList" :default-index="currentIndex" @confirm="onConfirm" class="selectGroup" @change="changeCity" @cancel="showPicker = false">
        <template #option="option">
          <span>{{ option.name }}</span>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import { weoauserCityList, weoauserGroupList } from "@/server/api.js";

export default {
  name: "usersList",
  props: ["show"],
  data() {
    return {
      status: 0,
      userOption: [],
      ruleForm: {
        selectArr: [],
      },
      showAllChecks: true,
      formatUsers: [],
      checked: false,
      total: 0, // 总条数
      userName: "",
      cityId: JSON.parse(localStorage.getItem("userInfo")).zsCityId + "", //当前登录者所属校区ID,
      // cityId: "1",//当前登录者所属校区ID,
      showPicker: false,
      allCityList: [], //所有校区列表
      currentCityObj: {},
      currentIndex: 0, //默认显示第几个
    };
  },
  async created() {
    await this.getUsers();
  },
  watch: {
    "ruleForm.selectArr": {
      handler(val) {
        if (val.length > 0) {
          this.$refs.ensureConfirm.style.opacity = 1;
        } else {
          this.$refs.ensureConfirm.style.opacity = 0.5;
        }

        if (this.$refs.checkboxes) {
          this.checked = val.length === this.$refs.checkboxes.length;
        }
      },
      deep: true,
    },

    // userOption() {
    //   this.$nextTick(() => {
    //     if (this.$refs.checkboxes) {
    //       this.checked = this.ruleForm.selectArr.length === this.$refs.checkboxes.length;
    //     }
    //   });
    // },

    checked(val) {
      if (val) {
        this.$refs.allChecked.style.color = "#277FFF";
      } else {
        this.$refs.allChecked.style.color = "#999999";
      }
    },
    userName(val) {
      if (!val) this.userOption = [...this.formatUsers];
    },
  },
  methods: {
    async getUsers() {
      const { data: resData } = await weoauserCityList();
      if (resData.code !== 200) return Toast.fail(resData.msg);
      this.allCityList = resData.data;
      this.allCityList.map((item, index) => {
        if (item.id === this.cityId) {
          this.currentCityObj = item;
          this.currentIndex = index;
        }
      });
      let params = {
        group_id: "",
        page: 1,
        page_size: 3000,
        city_id: this.cityId,
        user_name: "",
      };
      const { data: res } = await weoauserGroupList(params);
      if (res.code !== 200) return Toast.fail(res.msg);
      this.formatUsers = this.userOption = [...res.data];
    },

    //选中当前校区
    async onConfirm(val) {
      this.currentCityObj = val;
      this.showPicker = false;
      const { data: res } = await weoauserGroupList({
        group_id: "",
        page: 1,
        page_size: 3000,
        city_id: parseInt(this.currentCityObj.id),
      });
      if (res.code !== 200) return Toast.fail(res.msg);
      this.formatUsers = this.userOption = [...res.data];
      if (this.ruleForm.selectArr.length > 0) {
        if (this.ruleForm.selectArr.length === this.formatUsers.length) {
          this.checked = true;
        } else {
          this.checked = false;
        }
      }
    },

    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },

    //搜索人员
    searchCustomer() {
      if (!this.userName) {
        this.showAllChecks = true;
        return (this.userOption = [...this.formatUsers]);
      }
      let newarr = [];
      for (let i of this.formatUsers) {
        if (i.realname.indexOf(this.userName) >= 0) {
          newarr.push(i);
        }
      }
      this.userOption = [...new Set(newarr)];
      this.showAllChecks = false;
    },

    //切换校区触发回调
    changeCity() {
      this.userName = "";
    },

    //取消返回按钮
    resetUser() {
      this.$emit("cancelUser", false);
    },

    //全选
    allCheckbox() {
      if (this.checked) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll();
      }
    },

    //确认按钮
    ensureComfirm() {
      if (this.ruleForm.selectArr.length > 0) {
        this.$emit("appendUser", this.ruleForm.selectArr, false);
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.usersGroup {
  width: 100%;
  min-height: 100%;
  background: #f6f6f6;
  padding-top: 124px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  overflow-y: auto;

  .van-search {
    padding: 0;

    /deep/ .van-icon-search {
      font-size: 30px;
    }

    /deep/ .van-field__control {
      font-size: 28px;
    }
  }

  .van-search__content {
    height: 80px;
    padding-left: 30px;
    border-radius: 40px;
    background-color: #f3f3f3;
  }

  .van-search .van-cell {
    align-items: center;
  }

  .van-field__left-icon {
    height: 80px;
  }

  .user_wrap {
    padding: 20px 30px;
    margin-bottom: 122px;

    .header_checkbox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 14px;
      padding-right: 20px;

      h4 {
        font-size: 26px;
      }

      .allCheckbox {
        display: flex;
        align-items: center;

        span {
          font-size: 28px;
          margin-right: 10px;
          color: #999999;
        }

        /deep/ .van-icon {
          width: 26px;
          //height: 28px;
        }

        /deep/ .van-checkbox__icon {
          font-size: 26px;
        }

        /deep/ .van-checkbox__icon--checked {
          .van-icon-success {
            color: #277fff;
            border-color: #277fff;
            background-color: transparent;
          }
        }
      }
    }

    .van-cell-group {
      border-radius: 10px;
      overflow: hidden;

      &:after {
        border: none;
      }
    }

    .van-cell {
      padding: 14px 20px;

      &:after {
        border-bottom: 1px solid #dedede;
        right: 20px;
        left: 20px;
      }

      /deep/ .van-icon {
        width: 26px;
        height: 26px;
      }

      /deep/ .van-checkbox__icon {
        font-size: 26px;
      }

      /deep/ .van-checkbox__icon--checked {
        .van-icon-success {
          color: #277fff;
          border-color: #277fff;
          background-color: transparent;
        }
      }

      .flex-user {
        display: flex;
        align-items: center;

        .van-image {
          width: 60px;
          height: 60px;
          margin-right: 18px;
        }
        span {
          font-size: 28px;
        }
      }
    }
  }

  .search-text {
    font-size: 32px;
    padding-left: 20px;
    cursor: pointer;
  }

  .search {
    padding: 20px 30px 5px;
    background: #fff;
    position: fixed;
    width: 100%;
    top: 0;
    left: 50%;
    z-index: 100;
    transform: translate(-50%, 0);

    .margin-bot {
      margin-bottom: 16px;

      .flex-right-input {
        width: 250px;
        position: relative;
        margin-right: 28px;
        display: inline-flex;
        input {
          font-size: 28px;
          padding: 19px 12px 19px 20px;
          background-color: #f6f6f6;
          border-radius: 10px;
          width: 100%;
        }

        .van-icon-arrow-down {
          font-size: 30px;
          position: absolute;
          right: 16px;
          top: 22px;
          color: #b6b6b6;
        }
      }
    }
  }
}
</style>
